module.exports = __webpack_public_path__ + "img/armhole length back.4fa7e4a8.png";